import React, { useState } from 'react'
import classNames from 'classnames'
import { Category, CategoryList } from 'lib/types'
import { ReactComponent as ChevronDown } from 'lib/core/resources/svg/chevron-down.svg'
import { getChildrenCategories } from 'lib/core/resources/helpers'
import { RenderLink } from '../RenderLink'
import { RenderChildren } from '../RenderChildren'

interface Props {
  category: Category
  categoryList: CategoryList
}

export const NavItem = ({ category, categoryList }: Props) => {
  const categories = getChildrenCategories(category, categoryList)
  const hasChildren = !!categories
  const [isChildrenVisible, setChildrenVisible] = useState(false)

  function handleLinkClick (e: any) {
    if (hasChildren) {
      e.preventDefault()
      setChildrenVisible(!isChildrenVisible)
    }
  }

  return (
    <li
      key={category.id}
      className={classNames({
        hasChildren,
        isChildrenVisible
      })}
    >
      <RenderLink
        category={category}
        onClick={handleLinkClick}
      />

      {hasChildren && (
        <ChevronDown />
      )}

      {hasChildren && categories && isChildrenVisible && (
        <RenderChildren
          category={category}
          categories={categories}
          categoryList={categoryList}
        />
      )}
    </li>
  )
}
